import { render } from "./BlockInfo.vue?vue&type=template&id=d28a5458&scoped=true"
import script from "./BlockInfo.vue?vue&type=script&lang=js"
export * from "./BlockInfo.vue?vue&type=script&lang=js"

import "./BlockInfo.vue?vue&type=style&index=0&id=d28a5458&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d28a5458"]])

export default __exports__